<template>
  <div class="row">
    <div class="col-lg-12 px-sm-30px">
      <div class="card quick-stats-cont">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-3 d-flex justify-content-between align-items-center">
              <h6 class="text-white m-0 p-0 text-uppercase">Today's Active Stats</h6>
            </div>

            <div class="col-12 align-self-center text-capitalize">
              <div class="text-lg-left mt-lg-0">
                <div class="row">

                  <div class="col-sm-6 col-md-3 col-lg-3 mb-5 mb-md-0 quick-stat">
                    <div>
                      <img src="assets/images/index-icons/check.svg" alt="">
                      <div>
                        <p class="text-muted mb-2">Receipted Bills Today</p>
                        <h5 class="mb-0">
                          <div v-if="loading.receipted" class="text-center">
                            <div class="spinner-border spinner-border-sm text-primary" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                          <span v-else class="per-rand-num">{{numberFormat(recieptedBills.recieptedBills)}}</span>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 col-lg-3 mb-5 mb-md-0 quick-stat">
                    <div style="cursor: pointer;" @click="gotTo('un-paid-bills')">
                      <img src="assets/images/index-icons/unpaid-bills.png" alt="">
                      <div>
                        <p class="text-muted mb-2">Created Unpaid Bills Today</p>
                        <h5 class="mb-0">
                          <div v-if="loading.bills" class="text-center">
                            <div class="spinner-border spinner-border-sm text-primary" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                          <span v-else class="per-rand-num">{{numberFormat(dashboardBills.unpaidBills)}}</span>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 col-lg-3 mb-5 mb-md-0 quick-stat">
                    <div @click="gotTo('un-paid-bills')">
                      <img src="assets/images/index-icons/protection.png" alt="">
                      <div>
                        <p class="text-muted mb-2">Value Of unpaid Bills Today</p>
                        <h5 class="mb-0">
                          <div v-if="loading.bills" class="text-center">
                            <div class="spinner-border spinner-border-sm text-primary" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                          <span v-else class="per-rand-num">KES {{numberFormat(dashboardBills.unpaidBillsValue)}}</span>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-3 col-lg-3 mb-5 mb-md-0 quick-stat">
                    <div>
                      <img src="assets/images/index-icons/debt.png" alt="">
                      <div>
                        <p class="text-muted mb-2">Arrears</p>
                        <h5 class="mb-0"><span class="per-rand-num">0</span></h5>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { biller, execute } from "@/api";
import router from "@/router";

export default {
  name: "TodaysActiveStats",
  data() {
    return {
      loading: {
        receipted: true,
        bills: true
      },
      recieptedBills: {
        recieptedBills: 0
      },
      dashboardBills: {
        unpaidBillsValue: 0,
        unpaidBills: 0
      }
    }
  },
  mounted() {
    this.getDashboardReceiptedBills();
    this.getDashboardBills();
  },
  methods: {
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    gotTo(route) {
      router.push(route);
    },

    getDashboardReceiptedBills() {
      // Check for cached data with proper validation
      const cachedData = localStorage.getItem("dashboardReceiptedBills");
      if (cachedData && cachedData !== "undefined" && cachedData !== "null") {
        try {
          const parsedData = JSON.parse(cachedData);
          this.receiptedBills = parsedData;
          this.loading.receipted = false;
        } catch (e) {
          console.warn("Error parsing cached receipted bills data:", e);
          localStorage.removeItem("dashboardReceiptedBills");
        }
      }

      const data = new FormData();
      data.append("function", "dashboardReceiptedBills");
      data.append("sessionNames", localStorage.getItem("sessionNames"));
      data.append("sessionIdNo", localStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.receiptedBills = res.data.data.receiptedBills;
              this.loading.receipted = false;

              // Cache the data safely
              try {
                localStorage.setItem("dashboardReceiptedBills", JSON.stringify(this.receiptedBills));
              } catch (e) {
                console.warn("Failed to cache receipted bills data:", e);
              }
            } else {
              console.error("API Error:", res.data.message || "Unknown error");
              this.loading.receipted = false;
            }
          })
          .catch((e) => {
            console.error("Error fetching receipted bills:", e);
            this.loading.receipted = false;
          });
    },

    getDashboardBills() {
      // Check for cached data with proper validation
      const cachedData = localStorage.getItem("dashboardBills");
      if (cachedData && cachedData !== "undefined" && cachedData !== "null") {
        try {
          const parsedData = JSON.parse(cachedData);
          this.dashboardBills = parsedData;
          this.loading.bills = false;
        } catch (e) {
          console.warn("Error parsing cached bills data:", e);
          localStorage.removeItem("dashboardBills");
        }
      }

      const data = new FormData();
      data.append("function", "dashboardBills");
      data.append("sessionNames", localStorage.getItem("sessionNames"));
      data.append("sessionIdNo", localStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.dashboardBills = res.data.data.dashboardBills;
              this.loading.bills = false;

              // Cache the data safely
              try {
                localStorage.setItem("dashboardBills", JSON.stringify(this.dashboardBills));
              } catch (e) {
                console.warn("Failed to cache bills data:", e);
              }
            } else {
              console.error("API Error:", res.data.message || "Unknown error");
              this.loading.bills = false;
            }
          })
          .catch((e) => {
            console.error("Error fetching dashboard bills:", e);
            this.loading.bills = false;
          });
    }
  }
}
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.quick-stat {
  transition: all 0.3s ease;
}

.quick-stat:hover {
  transform: translateY(-2px);
}
</style>